
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { updateStoreUserNavbar, TabDto, getCompanyType } from '@/api/goodsModule'
import draggable from 'vuedraggable'

// 常驻导航模块
@Component({
  name: 'companyServe',
  components: {
    draggable
  }
})
export default class companyServe extends Vue {
  @Getter info: any // 用户信息
  @Getter userId!: string
  @Getter companyId!: string
  @Getter tabModules!: Array<TabDto>
  @Action setTabModules!: (val: Array<TabDto>) => void
  isEdit = false
  constNavList: Array<TabDto> = [
    {
      sortId: 1,
      applicationName: '首页',
      applicationLogo: 'tab-mall.png',
      isShow: false,
      route: '/mall'
    },
    {
      sortId: 2,
      applicationName: '分类',
      applicationLogo: 'tab-category.png',
      isShow: false,
      route: '/mallCategory'
    },
    {
      sortId: 3,
      applicationName: '购物车',
      applicationLogo: 'tab-shopcar.png',
      isShow: false,
      route: '/buyMallCar'
    },
    {
      sortId: 4,
      applicationName: '商品',
      applicationLogo: 'tab-goods.png',
      isShow: false,
      route: '/goods'
    }
  ]
  editList: Array<TabDto> = [] // 编辑中的列表
  companyInfo = {
    companyType: 1, // 0 常规企业 1 合作方企业 2 产业商城
    isNewCompany: 0 // 1：是 是否已经转为新版公司+店铺
  }

  checkboxChange (item: TabDto) {
    console.log('item...', item)
    if (item.isShow) {
      item.isShow = false
    } else {
      if (this.editList.filter(i => i.isShow).length === 3) {
        this.$toast('常驻导航不得超过3个')
      } else {
        item.isShow = true
      }
    }
  }

  handleFinish () {
    this.isEdit = !this.isEdit
    this.editList.forEach((tab, index) => {
      tab.sortId = index + 1
    })
    const navbarList = JSON.parse(JSON.stringify(this.editList))
    if (!this.isEdit) {
      updateStoreUserNavbar({ storeId: this.companyId, navbarList }).then(res => {
        this.$toast(res.msg)
        this.setTabModules(navbarList)
      })
    }
  }

  toModule (tab: TabDto) {
    if (!this.isEdit) {
      this.$router.push(tab.route)
    }
  }

  created() {
    getCompanyType({ companyId: this.companyId }).then(res => {
      this.companyInfo = res.data
      // isNewCompany = 1（有编辑、显示所有模块）
      if (this.companyInfo.isNewCompany === 1) {
        this.editList = JSON.parse(JSON.stringify(this.tabModules))
      } else { // 普通用户不显示 商品、不可编辑
        this.editList = JSON.parse(JSON.stringify(this.tabModules.filter(t => t.route !== '/goods')))
      }
    })
  }
}
